import React from 'react';
import {
  ViewButton,
  EditButton,
  DeleteButton,
} from '../Common/DataTable/tableActionButtons';
import { getFilter, getSort } from '../Common/DataTable/tableHelpers';
import moment from 'moment';

const createTableColumns = (openViewModal, openEditModal, handleDelete) => [
  {
    title: 'ID',
    name: 'id',
    hidden: true,
  },
  {
    title: 'Codice',
    name: 'code',
    width: 160,
    sort: true,
  },
  {
    title: 'Descrizione',
    name: 'description',
    width: 200,
    sort: true,
    formatterComponent: ({ value }) => value || 'N/A',
  },
  {
    title: 'Percentuale Sconto',
    name: 'discountPercentage',
    width: 140,
    sort: true,
    formatterComponent: ({ row }) =>
      row.discountPercentage !== undefined
        ? row.discountPercentage === 100
          ? 'Gratuito (100%)'
          : `${row.discountPercentage}%`
        : 'N/A',
    filter: (value, filter) => {
      const displayValue =
        value.discountPercentage !== undefined
          ? value.discountPercentage === 100
            ? 'Gratuito (100%)'
            : `${value.discountPercentage}%`
          : 'N/A';
      return getFilter(displayValue, filter.value);
    },
    sorting: (a, b) => {
      const aValue = a.discountPercentage ?? -1;
      const bValue = b.discountPercentage ?? -1;
      return getSort(aValue, bValue);
    },
  },
  {
    title: 'Stripe Coupon ID',
    name: 'stripeCouponId',
    width: 120,
    sort: true,
    formatterComponent: ({ row }) => row.stripeCouponId || 'N/A',
    filter: (value, filter) => {
      const displayValue = value.stripeCouponId || 'N/A';
      return getFilter(displayValue, filter.value);
    },
    sorting: (a, b) => {
      const aValue = a.stripeCouponId || '';
      const bValue = b.stripeCouponId || '';
      return getSort(aValue, bValue);
    },
  },
  {
    title: 'Utilizzi',
    name: 'currentUses',
    width: 80,
    sort: true,
    formatterComponent: ({ row }) =>
      `${row.currentUses}${row.maxUses ? `/${row.maxUses}` : ''}`,
    filter: (value, filter) => {
      const displayValue = `${value.currentUses}${
        value.maxUses ? `/${value.maxUses}` : ''
      }`;
      return getFilter(displayValue, filter.value);
    },
    sorting: (a, b) => getSort(a.currentUses, b.currentUses),
  },
  {
    title: 'Scadenza',
    name: 'expirationDate',
    width: 100,
    sort: true,
    formatterComponent: ({ value }) =>
      value ? moment(value).format('DD/MM/YYYY') : 'Mai',
    filter: (value, filter) => {
      const displayValue = value ? moment(value).format('DD/MM/YYYY') : 'Mai';
      return getFilter(displayValue, filter.value);
    },
    sorting: (a, b) => {
      const aValue = a ? moment(a).valueOf() : 0;
      const bValue = b ? moment(b).valueOf() : 0;
      return getSort(aValue, bValue);
    },
  },
  {
    title: 'Disabilita Rinnovo',
    name: 'disableAutoRenewal',
    width: 130,
    sort: true,
    formatterComponent: ({ value }) => (
      <span
        className={`badge badge-${value ? 'warning' : 'success'} font-size-12`}>
        {value ? 'Sì' : 'No'}
      </span>
    ),
    filter: (value, filter) => getFilter(value ? 'sì' : 'no', filter.value),
    sorting: (a, b) => getSort(a ? 'sì' : 'no', b ? 'sì' : 'no'),
  },
  {
    title: 'Stato',
    name: 'isActive',
    width: 80,
    sort: true,
    formatterComponent: ({ value }) => (
      <span
        className={`badge badge-${
          value ? 'success' : 'secondary'
        } font-size-12`}>
        {value ? 'Attivo' : 'Inattivo'}
      </span>
    ),
    filter: (value, filter) =>
      getFilter(value ? 'attivo' : 'inattivo', filter.value),
    sorting: (a, b) =>
      getSort(a ? 'attivo' : 'inattivo', b ? 'attivo' : 'inattivo'),
  },
  {
    title: 'Azioni',
    name: 'action',
    width: 150,
    align: 'center',
    formatterComponent: ({ row }) => (
      <ul className="list-inline font-size-20 contact-links mb-0">
        <ViewButton row={row} onPress={openViewModal} />
        <EditButton row={row} onPress={openEditModal} />
        <DeleteButton row={row} onPress={handleDelete} />
      </ul>
    ),
    filter: 'disabled',
    sorting: 'disabled',
  },
];

export default createTableColumns;
